import TripContent from "../../Components/Admin/IncomingTrip";
import NavbarMenu from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const IncomingTrip = () => {
  return (
    <>
      <NavbarMenu />
      <TripContent />

      <Footer />
    </>
  );
};

export default IncomingTrip;
